import { useCallback } from 'react';
import { LocalStorageKey } from './local-storage-key';

export const useLocalStorage = <T>() => {
    const getItem = useCallback((key: LocalStorageKey) => JSON.parse(localStorage.getItem(key)) as T, []);

    const setItem = useCallback(
        (key: LocalStorageKey, value: T) => localStorage.setItem(key, JSON.stringify(value)),
        []
    );

    return {
        getItem,
        setItem,
    };
};
